/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Width_LabelInputs */

const en_options_display_width_label = /** @type {(inputs: Options_Display_Width_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display Width (Characters)`)
};

const fr_options_display_width_label = /** @type {(inputs: Options_Display_Width_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largeur d'affichage (caractères)`)
};

const de_options_display_width_label = /** @type {(inputs: Options_Display_Width_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigebreite (Zeichen)`)
};

const it_options_display_width_label = /** @type {(inputs: Options_Display_Width_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Larghezza di visualizzazione (caratteri)`)
};

const ru_options_display_width_label = /** @type {(inputs: Options_Display_Width_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ширина отображения (символов)`)
};

const es_options_display_width_label = /** @type {(inputs: Options_Display_Width_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancho de pantalla (caracteres)`)
};

const zh_cn2_options_display_width_label = /** @type {(inputs: Options_Display_Width_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示宽度（字符）`)
};

const ja_options_display_width_label = /** @type {(inputs: Options_Display_Width_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示幅（文字数）`)
};

const hi_options_display_width_label = /** @type {(inputs: Options_Display_Width_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिस्प्ले की चौड़ाई (अक्षर)`)
};

const pt_pt2_options_display_width_label = /** @type {(inputs: Options_Display_Width_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largura de exibição (caracteres)`)
};

/**
* | output |
* | --- |
* | "Display Width (Characters)" |
*
* @param {Options_Display_Width_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_width_label = /** @type {((inputs?: Options_Display_Width_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Width_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_width_label(inputs)
	if (locale === "de") return de_options_display_width_label(inputs)
	if (locale === "it") return it_options_display_width_label(inputs)
	if (locale === "ru") return ru_options_display_width_label(inputs)
	if (locale === "es") return es_options_display_width_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_width_label(inputs)
	if (locale === "ja") return ja_options_display_width_label(inputs)
	if (locale === "hi") return hi_options_display_width_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_width_label(inputs)
	return en_options_display_width_label(inputs)
});